import React, { ReactNode } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './DisabledField.scss';

interface Props {
  isEditingDisabled: boolean;
  tooltipText: string;
  children: ReactNode;
}

const DisabledField = ({ isEditingDisabled, tooltipText, children }: Props) => {
  return (
    <span>
      {isEditingDisabled ? (
        <OverlayTrigger
          placement='top-start'
          overlay={(props) => (
            <Tooltip id='disabled-tooltip' className='disabled-tooltip text-xs' {...props}>
              {tooltipText}
            </Tooltip>
          )}
        >
          <span>{children}</span>
        </OverlayTrigger>
      ) : (
        <>{children}</>
      )}
    </span>
  );
};

export default DisabledField;
